import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const Navbar = ({ dark = true }) => (
  <motion.header
    initial={{ y: -30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className={`absolute top-0 left-0 right-0 z-40 ${dark ? "" : ""}`}
  >
    <div className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
      <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3 group">
        <img
          src="/logo-icon.jpg"
          alt="Parrucchiere Vincente"
          className="h-12 w-12 rounded-full object-cover ring-1 ring-[#C8A6A1]/40"
        />
        <div className="leading-tight text-left">
          <span
            className={`block font-display text-lg font-bold tracking-wide ${
              dark ? "text-[#F7F2EA]" : "text-[#2B1930]"
            }`}
          >
            Parrucchiere <span className="text-[#D83A52] italic">Vincente</span>
          </span>
          <span
            className={`block text-[10px] uppercase tracking-[0.3em] ${
              dark ? "text-[#C8A6A1]" : "text-[#2B1930]/60"
            }`}
          >
            Marketing esclusivo per saloni
          </span>
        </div>
      </Link>
    </div>
  </motion.header>
);
